import React, { useState } from 'react';
import homeIcon from '../../assets/icone/bottomBar/iconHomeOut.svg';
import homeIconFill from '../../assets/icone/bottomBar/iconaHomeFill.svg';
import preferitiIcon from '../../assets/icone/bottomBar/iconFavoriteOut.svg';
import preferitiIconFill from '../../assets/icone/bottomBar/iconaFavoriteFill.svg';
import vendiIcon from '../../assets/icone/bottomBar/iconSell.svg';            // <-- Grande icona "Sell"
import experienceIcon from '../../assets/icone/bottomBar/iconEsperienzeOutlined.svg';
import experienceIconFill from '../../assets/icone/bottomBar/iconEsperienzeFilled.svg';
import profiloIcon from '../../assets/icone/bottomBar/iconaProfiloOut.svg';
import profiloIconFill from '../../assets/icone/header/iconaProfiloFill.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BottomBar = () => {
  const [selected, setSelected] = useState('/');
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Array di icone + label nella navbar in basso
  const icons = [
    {
      name: t('bottomBar.home'),
      icon: homeIcon,
      iconFill: homeIconFill,
      route: '/'
    },
    {
      name: t('bottomBar.favorites'),
      icon: preferitiIcon,
      iconFill: preferitiIconFill,
      route: '/favorite'
    },
    {
      // QUI mettiamo solo il testo "Vendi", senza icona (o icona vuota)
      name: t('buttons.sell'),
      icon: '', // Nessuna icona (oppure un placeholder trasparente)
      iconFill: '',
      route: '/sellTicket'
    },
    {
      name: t('bottomBar.experiences'),
      icon: experienceIcon,
      iconFill: experienceIconFill,
      route: '/experience'
    },
    {
      name: t('bottomBar.profile'),
      icon: profiloIcon,
      iconFill: profiloIconFill,
      route: '/profile'
    },
  ];

  return (
    <nav aria-label="Navigazione mobile" role="navigation" className="fixed bottom-0 w-screen bg-white p-2 py-4 z-40 shadow-xl">

      {/* ICONA "GRANDE" VENDI ASSOLUTAMENTE POSIZIONATA */}
      <button
        className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-12
                    rounded-full flex flex-col items-center cursor-pointer p-2 bg-transparent border-0"
        onClick={() => {
          setSelected('/sellTicket');
          navigate('/sellTicket');
        }}
        aria-label={t('buttons.sell')}
      >
        <img src={vendiIcon} alt="" className="w-20" aria-hidden="true" />
        {/*  RIMOSSO il testo da qui, per allinearlo nella navbar  */}
      </button>

      {/* NAVBAR INFERIORE CON LABEL ALLINEATE */}
      <ul className="flex justify-around items-center list-none m-0 p-0">
        {icons.map((item) => (
          <li key={item.route} className="flex-1">
            <button
              className="w-full flex flex-col items-center cursor-pointer bg-transparent border-0 p-0"
              onClick={() => {
                setSelected(item.route);
                navigate(item.route);
              }}
              aria-current={selected === item.route ? 'page' : undefined}
              aria-label={item.name}
            >
              {/* Se esiste l'icona, la mostri. Altrimenti uno span vuoto o un placeholder */}
              {item.icon ? (
                <img
                  src={selected === item.route && item.iconFill ? item.iconFill : item.icon}
                  alt=""
                  aria-hidden="true"
                  className={`w-6 ${selected === item.route ? 'opacity-100' : 'opacity-60'}`}
                />
              ) : (
                // Un piccolo placeholder "finto" giusto per conservare l'allineamento verticale
                <div className="w-6 h-6 " aria-hidden="true" />
              )}

              <span className={`text-sm text-center ${selected === item.route ? 'font-bold' : ''}`}>
                {item.name}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BottomBar;
